import CreatableSelect from './CreatableSelect'

export default CreatableSelect
